export default "__VITE_ASSET__BNplTd9d__"